export enum PollStatus {
	Closed = 'Closed',
	Open = 'Open',
	Published = 'Published'
}
